/**
 * Centralized brand configuration — the frontend source of truth for the
 * RESIDENNCE brand board. Nothing should hard-code these values inline.
 */

export const BRAND = {
  company: "RESIDENNCE",
  product: "AgentHQ",
  assistant: "RESA",
  assistantFull: "Real Estate Strategic Assistant",
  tagline: "The intelligent business operating system for real estate agents.",
};

// Approved brand palette (exact hex).
export const COLORS = {
  royalNavy: "#0A1530",
  premiumGold: "#D4AF37",
  pureWhite: "#FFFFFF",
  charcoal: "#1A1A1A",
  lightGray: "#F2F4F7",
  softGold: "#E6C97A",
  burgundy: "#5B1E22",
  deepBlue: "#102A43",
};

export const PALETTE = [
  { name: "Royal Navy", token: "brand.navy", hex: COLORS.royalNavy, role: "Primary brand foundation / navigation", onDark: true },
  { name: "Premium Gold", token: "brand.gold", hex: COLORS.premiumGold, role: "Selective accent", onDark: true },
  { name: "Soft Gold", token: "brand.soft-gold", hex: COLORS.softGold, role: "Muted accent / highlights", onDark: false },
  { name: "Deep Blue", token: "brand.deep-blue", hex: COLORS.deepBlue, role: "Secondary depth / info", onDark: true },
  { name: "Burgundy", token: "brand.burgundy", hex: COLORS.burgundy, role: "Editorial / destructive tone", onDark: true },
  { name: "Charcoal", token: "brand.charcoal", hex: COLORS.charcoal, role: "Primary text", onDark: true },
  { name: "Light Gray", token: "brand.light-gray", hex: COLORS.lightGray, role: "Workspace surfaces", onDark: false },
  { name: "Pure White", token: "brand.white", hex: COLORS.pureWhite, role: "Base surface", onDark: false },
];

// Official approved brand assets (visual source of truth), served from /public.
export const ASSETS = {
  logoNavy: "/brand/logo-navy.png", // primary logo (gold wordmark on navy)
  wordmark: "/brand/logo-wordmark-trim.png", // transparent gold wordmark + tagline
  mark: "/brand/brand-mark.png", // circular R brand mark (transparent)
  favicon: "/brand/favicon.png",
  brandBoard: "/brand/brand-board.png",
};

export const TYPOGRAPHY = {
  brand: { name: "Playfair Display", stack: "serif", use: "Selective RESIDENNCE brand & editorial headings" },
  ui: { name: "Manrope", stack: "sans-serif", use: "All application UI — nav, forms, tables, data" },
};
